var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88447 11.9059C2.88447 12.3184 3.04655 12.7141 3.33507 13.0058C3.62359 13.2975 4.0149 13.4614 4.42293 13.4614H10.5768C10.9848 13.4614 11.3761 13.2975 11.6646 13.0058C11.9531 12.7141 12.1152 12.3184 12.1152 11.9059V2.57254H2.88447V11.9059ZM4.42293 4.12809H10.5768V11.9059H4.42293V4.12809ZM10.1922 0.239204L9.42293 -0.538574L5.57677 -0.538574L4.80754 0.239204H2.11523V1.79476H12.8845V0.239204H10.1922Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTrash);
export default __webpack_public_path__ + "static/media/edit-trash.eae36c58.svg";
export { ForwardRef as ReactComponent };